import { lazy, Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAppStore } from "@/store";
import { PageHeader, Breadcrumbs, PageSkeleton } from "@/components/ui";

const SamplingCalendarView = lazy(() =>
  import("@/components/schedules/calendar/sampling-calendar").then((m) => ({
    default: m.SamplingCalendarView,
  })),
);

export const Route = createFileRoute("/_authenticated/sampling/calendar")({
  component: SamplingCalendarPage,
});

function SamplingCalendarPage() {
  const { t } = useTranslation("schedules");
  const orgId = useAppStore((s) => s.activeOrgId);

  if (!orgId) {
    return null;
  }

  return (
    <div className="p-8">
      <Breadcrumbs items={[{ label: t("calendar.title") }]} />

      <PageHeader title={t("calendar.title")} />

      <div className="mt-6">
        <Suspense fallback={<PageSkeleton />}>
          <SamplingCalendarView orgId={orgId} />
        </Suspense>
      </div>
    </div>
  );
}
